var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235.08 235.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #6666cd;\n      }\n\n      .cls-2 {\n        stroke: #6666cd;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 235.08,
    height: 235.08,
    rx: 64.13,
    ry: 64.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 92.75,
    cy: 117.54,
    r: 48.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.16,
    y: 85.07,
    width: 64.67,
    height: 64.75,
    rx: 6.1,
    ry: 6.1,
    transform: "translate(127.42 -72.72) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.39,106.51l25.22,9.33c1.7.63,1.7,3.03,0,3.66l-25.22,9.33c-3.21,1.19-5.74,3.72-6.93,6.93l-9.33,25.22c-.63,1.7-3.03,1.7-3.66,0l-9.33-25.22c-1.19-3.21-3.72-5.74-6.93-6.93l-25.22-9.33c-1.7-.63-1.7-3.03,0-3.66l25.22-9.33c3.21-1.19,5.74-3.72,6.93-6.93l9.33-25.22c.63-1.7,3.03-1.7,3.66,0l9.33,25.22c1.19,3.21,3.72,5.74,6.93,6.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.db614d12c5d640a9e7edc227c8794b6a.svg";
export { ForwardRef as ReactComponent };